import { render } from "./save-name-popup.vue?vue&type=template&id=bd114fce&scoped=true"
import script from "./save-name-popup.vue?vue&type=script&lang=js"
export * from "./save-name-popup.vue?vue&type=script&lang=js"

import "./save-name-popup.vue?vue&type=style&index=0&id=bd114fce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd114fce"]])

export default __exports__